export enum ProjectTabs {
    Materials = 0,
    Labor = 1,
    Misc = 2,
    Estimate = 3,
    Review = 4,
    Reports = 5,
}

export enum LIBRARY_TABS {
    Preview = 0,
    ProjectView = 1,
    CostSummaryView = 2,
    LibraryView = 3,
    ReportView = 4
}

export enum CollabViewButtons {
    acceptDiscard = 'acceptDiscard',
    acceptPublish = 'acceptPublish',
    decline = 'decline'
}

export enum MenuItems {
    file = 'file',
    edit = 'edit',
    view = 'view',
    tools = 'tools',
    window = 'window',
    help = 'help'
}

export enum ToolsMenu {
    productPromotion = 'product_promotion',
    subsidyProgram = 'subsidy_program',
    material_checker = 'material_checker',
    displayLanguageSettings = 'display_language_settings',
    synchronizationData= 'synchronization_data'
}

export enum FileMenu {
    properties = 'properties',
    customer_information = 'customer_information',
    open = 'open',
    opportunity = 'opportunity',
    create_opportunity = 'create_opportunity',
    link_opportunity = 'link_opportunity',
    export_proposal = 'export_proposal',
    recent = 'recent',
    close = 'close',
    save = 'save',
    SAP_submittal = 'SAP_submittal',
    Turnover_to_Sales = 'turnover_to_sales',
    exit = 'exit'
}

export enum LaborHoursDistRowEnum {
    STRAIGHT_TIME = 0,
    SHIFT_DIFFERENTIAL_RATE = 1,
    OVERTIME_TIME_AND_1_2 = 2,
    OVERTIME_DOUBLE_TIME = 3,
    PREVAILING_WAGE_RATE = 4,
    PWR_SHIFTS_DIFFERENTIAL_RATE = 5,
    PREVAILING_WAGE_RATE_TIME_AND_1_2 = 6,
    PREVAILING_WAGE_RATE_DOUBLE_TIME = 7,
}

export enum LaborHoursDistColumnEnum {
    DESCRIPTION = 0,
    NUMBER_IN_AREA = 1,
    PM = 2,
    ENG = 3,
    CENG = 4,
    EENG = 5,
    LENG = 6,
    NENG = 7,
    QENG = 8,
    GRAP = 9,
    PROG = 10,
    SPEC = 11,
    DDS = 12,
    MECH = 13,
    ELEC = 14
}

export enum PlannedCostLaborFields {
    PROJECT_MANAGER = 21,
    MECHANICAL = 32,
    ELECTRICAL = 33,
    SPECIALIST = 30,
    ENGINEER = 22,
    GRAPHICS = 28,
    PROGRAMMING = 29,
    DIGITAL_DEPLOYMENT_SPECIALIST = 31,
    CENGINEER = 23,
    EENGINEER = 24,
    LENGINEER = 25,
    NENGINEER = 26,
    QENGINEER = 27
}

export enum EstimateType {
    None = 0,
    EstimateLess50K = 1,
    Estimate50_150K = 2,
    EstimateGreater150K = 3
}

export enum CostReviewType {
    None = 0,
    AutomationEnUs = 1,
    FireEnUs = 2,
    SecurityEnUs = 3,
    ServiceAgreementEnUs = 4,
    ElectricalEnUs = 5,
    MechanicalEnUs = 6
}


export enum SolEstimatePricingMode {
    Fixed_Margin = 'M',
    Line_Item = 'L',
    Fixed_Price = 'P'
}

export enum SolMaterialEscalationType {
    Siemens_Material = 'SIEMENS_MATERIAL',
    Outside_Material = 'OUTSIDE_MATERIAL',
    Mechanical_Material = 'MECHANICAL_MATERIAL',
    Electrical_Material = 'ELECTRICAL_MATERIAL'
}

export enum SolLaborEscalationType {
    Project_Management = 'PROJECT_MANAGEMENT',
    Engineering = 'ENGINEERING',
    CYBER_SECURITY_ENGINEERING = 'CYBER_SECURITY_ENGINEERING',
    ENERGY_ENGINEERING = 'ENERGY_ENGINEERING',
    ELECTRICAL_ENGINEERING = 'ELECTRICAL_ENGINEERING',
    NETWORK_ENGINEERING = 'NETWORK_ENGINEERING',
    QUALIFICATION_ENGINEERING = 'QUALIFICATION_ENGINEERING',
    GRAPHICS = 'GRAPHICS',
    PROGRAMMING = 'PROGRAMMING',
    SPECIALIST = 'SPECIALIST',
    DIGITAL_DEPLOYMENT_SPECIALIST = 'DIGITAL_DEPLOYMENT_SPECIALIST',
    MECHANICAL = 'MECHANICAL',
    ELECTRICAL = 'ELECTRICAL'
}

export enum EscalationPeriod {
    FIRST_YEAR_PERCENTAGE = "FirstYearPercentage",
    SECOND_YEAR_PERCENTAGE = "SecondYearPercentage",
    THIRD_YEAR_PERCENTAGE = "ThirdYearPercentage",
    FOURTH_YEAR_PERCENTAGE = "FourthYearPercentage",
    FIFTH_YEAR_PERCENTAGE = "FifthYearPercentage"
}

export enum MaterialReportType {
    Siemens_Material = 'Siemens Material',
    Outside_Material = 'Outside Material',
    Mechanical_Material = 'Mechanical Material',
    Electrical_Material = 'Electrical Material',
    SI_OEM_Material = 'SI OEM Material',
    Siemens_Material_FR = 'Mat\u00e9riel Siemens',
    Outside_Material_FR = 'Mat\u00e9riel ext\u00e9rieur',
    Mechanical_Material_FR = 'Mat\u00e9riel m\u00e9canique',
    Electrical_Material_FR = 'Mat\u00e9riel \u00e9lectrique',
    SI_OEM_Material_FR = 'Mat\u00e9riel SI OEM',
    SHIPPING_HANDLING = 'Shipping & Handling',
    WARRANTY = 'Warranty'
}

export enum SubSidyProgramMaterialType {
    Siemens_Material = 1,
    Outside_Material = 2,
    Mechanical_Material = 3,
    Electrical_Material = 4
}

export enum ProjectCategoryVerification{
    ProjectCategory0 = 0,
    ProjectCategory1 = 1,
    ProjectCategory2 = 2,

}

export enum NodeType {
    Area = 'Area',
    System = 'BSETSystem',
    DesigoOptic = 'Desigo Optic',
    DesigoCC = 'DesigoCC',
    Panel = 'Panel',
    Controller = 'Controller',
    Project = 'Project'
}

export enum MaterialIndicatorsOptionId {
    SHOW_RPN = 'RPN',
    SHOW_APN = 'APN',
    SHOW_UPN = 'UPN',
    SHOW_Si_PARTS = 'SiParts'
}

export enum ViewMenu {
    materialIndicator = 'materialIndicator',
    showInputOutput = 'showInputOutput',
    colorSymbols = 'colorSymbols'
}

export enum LaborReportType {
    Project_Management_Labor = 'Project Management Labor',
    Engineer_Labor = 'Engineer Labor',
    CENG_Labor = 'Cyber Security Engineer Labor',
    EENG_Labor = 'Energy Engineer Labor',
    LENG_Labor = 'Electrical Engineering Labor',
    NENG_Labor = 'Network Engineer Labor',
    QENG_Labor = 'Qualification Engineer Labor',
    Programming_Labor = 'Programming Labor',
    Graphics_Labor = 'Graphics Labor',
    Specialist_Labor = 'Specialist Labor',
    Digital_Deployment_Labor = 'Digital Deployment Labor',
    Electrical_Engineer_Labor = 'Electrical Engineer Labor',
    Mechanical_Engineer_Labor = 'Mechanical Engineer Labor',
    Electrician_Engineer_Labor = 'Electrician Engineer Labor',
}

export enum MiscProjectInformationType {
    Miscellaneous_Cost = 'Miscellaneous',
    Productivity_Reserve = 'Productivity',
    Risk_Cost = 'Risk',
    Subcontractor_Fee = 'Subcontractor',
    Travel_Expense = 'Travel',

}

export enum FireEstimateAnalysisType {
    FIRE_ALARM = 'FIRE_ALARM',
    FIRE_SPRINKLER = 'FIRE_SPRINKLER',
    GASEOUS_SYSTEM = 'GASEOUS_SYSTEM',
    ERCES = 'ERCES'
}

export enum DateControlType {
    ALL_DATES = 0,
    BEFORE = 1,
    AFTER = 2,
    DURING = 3
}

export enum ProblemDetailsHttpStatus {
    NetworkError = 0,
    BadRequest = 400,
    Unauthorized = 401,
    Forbidden = 403,
    NotFound = 404
}

export enum WindowsMenus {
    workspace = 'workspace'
}

export enum TaxTypes {
    SalesTax = 0,
    UseTax = 1,
    BOTax = 2,
    NoTax = 3,
    HST = 4,
    PST = 5,
    GeneralTax = 6
}

export enum PropertyOptionId {
    ESTIMATE_SETTINGS = 'Estimate Settings',
    ESTIMATE_COLLABORATION = 'Estimate Collaboration',
    ESTIMATE_INSTALL_TYPE = 'Estimate Install Type',
    ESTIMATE_STATISTICS = 'Estimate Statistics',
    ELECTRICAL_SERVICES = 'Electrical Services',
    SIZING_SETTINGS = 'Sizing Settings',
    TASK_BASED_LABOR = 'Task Based Labor',
    TRAVEL_SETTINGS = 'Travel Settings',
    TAX_SETTINGS = 'Tax Settings',
    LABOR_RATES = 'Labor Rates',
    OVERTIME_RATES = 'Overtime Rates',
    PROPOSAL = 'Proposal',
    PROPOSAL_CUSTOMER_INFO = 'Proposal Customer Info'
  }

export enum EditMenu {
    preferences = 'preferences'
}

export enum PreferencesOptionId {
    COLLABORATORS = 'Collaborators',
    COST_REVIEWERS = 'Cost Reviewers',
    CONTACT_INFO = 'Contact Info',
    ESTIMATOR = 'Estimator (Si-Quote User)',
    DISPLAY_UNITS = 'Display/Units',
    COST_REVIEW_CC = 'Cost Review CC'
}

export enum Division
{
    BPS = "BPS",
    SER = 'SER',
    SOL = 'SOL'
}

/**
* Enum for material sub-categories used in shipping, warranty, and cost calculations.
* These represent the four material classification buckets.
*/
export enum MaterialSubCategory {
	Siemens = 'siemens',
	Outside = 'outside',
	Mechanical = 'mechanical',
	Electrical = 'electrical',
}

export enum EstimateSubSegmentType {
    SOLUTION = 1,
    SERVICE = 2,
    QUOTED_SERVICE = 3
}

export enum CULTURE_ID {
  EN_US = 1,
  FR_CA = 2,
  EN_CA = 3
}


export enum CostReviewPlannedCostItemName {
    projectManagement              = 'Project Manager',
    engineering                    = 'Engineer',
    networkEngineering             = 'Network Engineer',
    qualificationEngineering       = 'Qualification Engineer',
    cyberSecurityEngineering       = 'Cyber Security Engineer',
    energyEngineering              = 'Energy Engineer',
    electricalEngineering          = 'Electrical Engineer',
    graphics                       = 'Graphics',
    programming                    = 'Programming',
    specialist                     = 'Specialist',
    digitalDeploymentSpecialist    = 'Digital Deployment Specialist',
    mechanical                     = 'Mechanical',
    electrical                     = 'Electrical'
}

export enum WbsIds {
  Programmer = 1,
  Graphic = 2,
  Dds = 3
}

export enum DiscountType{
    DISCOUNT_TYPE_0 = 0,
    DISCOUNT_TYPE_1 = 1,
    DISCOUNT_TYPE_2 = 2
}


export enum TaxRateIndex {
    Material = 0,
    Labor = 1
}

export enum InstallTypeId {
    Parts=1,
    PartsAndSmarts=2,
    SoftTurnkeySubcontract=3,
    SoftTurnkeySelfPerform=4,
    TurnkeySubcontract=5,
    TurnkeySelfPerform=6,
    UserDefined = 7
}

/// <summary>
/// Enum which holds Skill Levels
/// </summary>
export enum SkillLevels {
  None = 0,
  Learning = 1,
  Proficient = 2,
  Master = 3
}

export enum SubSegmentID{
    //en_US = 1
AUTOMATION_SERVICE_PROJECT_US = 3,
MECHANICAL_SERVICE_PROJECT_US = 8,
AUTOMATION_SERVICE_PROJECT_CN_EN = 11,
MECHANICAL_SERVICE_PROJECT_CN_EN = 16,
AUTOMATION_SERVICE_PROJECT_CN_FR = 19,
MECHANICAL_SERVICE_PROJECT_CN_FR = 24
    //fr_CA = 2
    //en_CA = 3
}